import $ from './el.JsModules.js';

class Header {
  static MINIMUM_DISTANCE_FROM_TOP_BEFORE_HIDDEN = 80;
  static OPAQUE_HEADER_SCROLL_THRESHOLD = 300;
  constructor() {
    if (Header.instance) {
      // This is a singleton, do not allow more than once instance
      return Header.instance;
    }
    Header.instance = this;
    this.initialise();
  }

  initialise = () => {
    this.headerGroupElement = $('.header-group');
    this.mobilePrimaryNavigationOpen = false;
    this.lastScrollY = 0;
    this.headerIsOpaque = false;

    this.handleScrollEvent(null, window.scrollY, true);

    $('.primary-nav-button-mobile').click(this.handleMobilePrimaryNavButtonClick);

    $('.mobile-nav__main-menu-items').on('click', '.mobile-nav__menu-link', (evt) => {
      this.openMobileSubmenu(evt);
    });

    $('.mobile-nav').on('click', '.mobile-nav__menu-go-back', (evt) => {
      this.closeMobileSubmenu(evt);
    });

    $('.el-header__secondary-nav-link--search').click((evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      $('.boost-search-overlay-hidden-trigger-element').focus();
    });

    $('.el-header__menu').on('click', '.el-header__menu-item', (evt) => {
      const menuItem = $(evt.currentTarget);
      if (menuItem.hasClass('el-header__menu-item--active')) {
        return; // This submenu was already open let them follow the link
      }

      const submenuOptions = $(menuItem.find('template').html());

      if (submenuOptions.find('.desktop-nav__menu-item, .desktop-nav__feature-image').length <= 0) {
        // let the navigation happen, there is no submenu specified
        elabs.bodyElement.removeClass('primary-nav-open');
        this.mobilePrimaryNavigationOpen = false;
        return;
      }

      $('.el-header__menu-item--active').removeClass('el-header__menu-item--active');
      menuItem.addClass('el-header__menu-item--active');
      elabs.bodyElement.addClass('primary-nav-open');
      this.mobilePrimaryNavigationOpen = true;

      $('.el-header__desktop-primary-nav-drop-down-menu').html(submenuOptions);
      evt.stopPropagation();
      evt.preventDefault();

      $('.el-header').on('mouseleave', () => {
        elabs.bodyElement.removeClass('primary-nav-open');
        this.mobilePrimaryNavigationOpen = false;
        $('.el-header__menu-item--active').removeClass('el-header__menu-item--active');
        $('.el-header__desktop-primary-nav-drop-down-menu').html('');
      });
    });

    elabs.documentElement.on('WINDOW_SCROLL_EVENT', this.handleScrollEvent.bind(this));
    elabs.documentElement.on('WINDOW_RESIZED_EVENT', this.handleResizeEvent.bind(this));
  };

  handleScrollEvent = (evt, scrollY, preventHide = false) => {
    if (this.mobilePrimaryNavigationOpen) {
      return;
    }

    if (scrollY > this.lastScrollY + 20 && scrollY > Header.MINIMUM_DISTANCE_FROM_TOP_BEFORE_HIDDEN) {
      if (preventHide !== true) {
        this.headerGroupElement.addClass('header-group--hidden');
      }
      requestTimeout(() => {
        this.headerGroupElement.addClass('header-group--opaque');
        this.headerIsOpaque = true;
      }, 660); // 660 is the time it takes for the header to slide up and be hidden, then we make it opaque off screen
      this.lastScrollY = scrollY;
    } else if (scrollY < this.lastScrollY - 10) {
      this.headerGroupElement.removeClass('header-group--hidden');
      this.lastScrollY = scrollY;
    }

    if (this.headerIsOpaque && scrollY <= Header.OPAQUE_HEADER_SCROLL_THRESHOLD) {
      this.headerGroupElement.removeClass('header-group--opaque');
      this.headerIsOpaque = false;
    }
  };

  handleMobilePrimaryNavButtonClick = () => {
    this.mobilePrimaryNavigationOpen = !this.mobilePrimaryNavigationOpen;
    elabs.bodyElement.toggleClass('primary-nav-open');
  };

  handleResizeEvent = () => {
    if (this.mobilePrimaryNavigationOpen === true && elabs.windowElement.width() >= 1100) {
      this.handleMobilePrimaryNavButtonClick();
    }
  };

  openMobileSubmenu = (evt) => {
    const $menuItem = $(evt.currentTarget).closest('.mobile-nav__menu-item');
    let submenuItems = $(evt.currentTarget).closest('.mobile-nav__menu-item').find('template').html();
    submenuItems = $(submenuItems);

    if (submenuItems.find('.mobile-nav__menu-link:not(.mobile-nav__menu-link--view-all)').length <= 0) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    $('.mobile-nav').addClass('mobile-nav--sub-menu-open');

    requestTimeout(() => {
      $('.mobile-nav__main-menu-items').hide();
      $('.mobile-nav__sub-menu-items').html(submenuItems).css('display', 'flex');

      requestTimeout(() => {
        $('.mobile-nav__sub-menu-items').addClass('mobile-nav__sub-menu-items--visible');

        const submenuItemsSize = parseInt($menuItem.data('submenu-items-size'), 10);
        if (submenuItemsSize > 7) {
          this.hideMobilePromotion();
        }
      }, 1);
    }, 301);
  };

  closeMobileSubmenu = (evt) => {
    $('.mobile-nav__sub-menu-items').removeClass('mobile-nav__sub-menu-items--visible');
    requestTimeout(() => {
      $('.mobile-nav__sub-menu-items').html('').hide();
      $('.mobile-nav__main-menu-items').css('display', '');
      requestTimeout(() => {
        $('.mobile-nav').removeClass('mobile-nav--sub-menu-open');
        this.showMobilePromotion();
      }, 1);
    }, 305);
  };

  showMobilePromotion = () => {
    $('.mobile-nav__promotion').css('display', 'flex');
  };

  hideMobilePromotion = () => {
    $('.mobile-nav__promotion').css('display', 'none');
  };

  static getInstance() {
    if (!Header.instance) {
      Header.instance = new Header();
    }
    return Header.instance;
  }
}

elabs.onJavascriptReady(function () {
  elabs.Header = Header.getInstance();
});
